import { FlexComponent } from "src/typings/flexFramework/FlexComponent";

export interface LobNavigationProps {
  lobs: FlexComponent[];
}

export enum scrimValues {
  EMPTY = "",
  LEFT = "left",
  RIGHT = "right",
  BOTH = "both",
}

export interface LobNavigationScrimsProps {
  scrimsToDisplay: scrimValues;
}
